/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM, pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : IMAGE TOGGLE : STYLES --------------- ++++++++++ */
export default theme => ({
	image_toggle: {
		width: '100%',
	}, 
	controls: {
        flex: replacePXinStringWithEM('0 0 110px'),
        width: '100%',
        position: 'relative',
        '& .innerControls': {
            '& .field.name-imagetype': {
                display: 'none',
                marginBottom: pxToEm(12) // same as imageTypes
            },
        }
    }
});
